module.exports = __webpack_public_path__ + "img/1F603.8a3ba727.svg";